import React, {Component} from 'react';
import {Check, FileDownload, HighlightOff, Search, CalendarTodayOutlined} from '@mui/icons-material';
import {Alert, Button, CircularProgress, Collapse, IconButton, Popover, TextField, Tooltip, Typography} from '@mui/material';
import {StaticDateRangePicker} from '@mui/x-date-pickers-pro';
import {LocalizationProvider} from "@mui/x-date-pickers/LocalizationProvider";
import {isEqual} from 'lodash';
import moment from 'moment';
import {connect} from 'react-redux';

import {getSMSReportExportJobID, getSMSReportPolling} from '../../actions/smsHistory';
import Select from '../../components/Select';
import {dateFormat} from '../../lib/utils';
import Heading from '../NewDashboard/Heading';

const langMap = {TRANS: 'Transactional', PROMO: 'Promotional', OTP: 'OTP', ALL: 'ALL', Promotional: 'Promotional', Transactional: 'Transactional'};
const JOB_ID_KEY = 'epadhaiExportJobID'
const JOB_URL_KEY = 'epadhaiExportJobURL'

const shortcutsItems = [
  {
    label: 'Today',
    getValue: () => {
      const today = moment();
      return [today.clone().startOf('day'), today.clone().endOf('day')];
    }
  },
  {
    label: 'This Week',
    getValue: () => {
      const today = moment();
      return [today.clone().startOf('week'), today.clone().endOf('week')];
    }
  },
  {
    label: 'Last Week',
    getValue: () => {
      const today = moment();
      const prevWeek = today.subtract(7, 'd');
      return [prevWeek.clone().startOf('week'), prevWeek.clone().endOf('week')];
    }
  },
  {
    label: 'Last 7 Days',
    getValue: () => {
      const today = moment();
      return [today.clone().subtract(7, 'd'), today];
    }
  },
  {
    label: 'Current Month',
    getValue: () => {
      const today = moment();
      return [today.clone().startOf('month'), today.clone().endOf('month')];
    }
  },
  {
    label: 'Previous Month',
    getValue: () => {
      const today = moment();
      const startOfPreviousMonth = today.clone().startOf('month').subtract(1, 'month');
      return [startOfPreviousMonth, startOfPreviousMonth.clone().endOf('month')];
    }
  },
  {label: 'Reset', getValue: () => [null, null]}
];

class Filter extends Component {
  constructor(props) {
    super(props);
    const startDate = moment().startOf('month')
    const endDate = moment()
    this.state = {
      smsType: 'ALL',
      startDate,
      endDate,
      mobileNo: '',
      senderIds: props.smsDetails && props.smsDetails.senderIds ? props.smsDetails.senderIds : [],
      showWait: false,
      jobId: window.localStorage.getItem(JOB_ID_KEY) || null,
      isJobCompleted: !!window.localStorage.getItem(JOB_URL_KEY) || false,
      anchorEl: null
    };
    this.senderIds = this.state.senderIds
    this.date = {startDate, endDate}
    this.poll = null
  }

  componentDidMount() {
    if (this.state.jobId) {
      this.pollReport(this.state.jobId)
    }
  }

  componentWillUnmount() {
    if (this.poll) {
      this.poll.cancelPoll()
    }
  }

  componentWillReceiveProps(nextProps) {
    let {smsHistoryExportJobID} = nextProps;
    if(!this.state.jobId && smsHistoryExportJobID){
      if(smsHistoryExportJobID.success){
        this.setState({jobId: smsHistoryExportJobID.jobId, showWait: false, isJobCompleted: false})
        window.localStorage.setItem(JOB_ID_KEY, smsHistoryExportJobID.jobId);
        window.localStorage.removeItem(JOB_URL_KEY);
        this.pollReport(smsHistoryExportJobID.jobId)
      } else if(smsHistoryExportJobID.err){
        alert(smsHistoryExportJobID.err.msg);
        this.setState({showWait: false})
      } else{
        alert("Something went wrong, please try again!");
        this.setState({showWait: false});
      }
    }
  }

  pollReport = (jobId) => {
    this.poll = getSMSReportPolling(jobId)
    this.poll.poll().then(response => {
      if(response?.status === 'COMPLETED') {
        window.localStorage.setItem(JOB_URL_KEY, response.downloadUrl)
        const a = document.getElementById('download-full-report');
        if (a) {
          this.setState({isJobCompleted: true})
        } else {
          throw new Error("element not found")
        }
      } else {
        alert('Report export failed, please try again!')
      }
      window.localStorage.removeItem(JOB_ID_KEY);
      this.setState({jobId: null});
    })
      .catch(err=>{
        console.log(err);
      })
  }

  handleExport = () => {
    const a = document.getElementById('download-full-report');
    a.href = `${ window.localStorage.getItem(JOB_URL_KEY) }`;
    a.click();
    window.localStorage.removeItem(JOB_URL_KEY);
    this.setState({isJobCompleted: false})
  }

  handleChange = (event) => {
    this.setState({smsType: event.target.value}, () => this.props.applyFilter(this.state))
  }

  handleDateChange = (date) => {
    this.setState({startDate: date[0], endDate: date[1]})
  }

  handleClick = (event) => {
    this.setState({anchorEl: event.currentTarget});
  };

  handleClose = (date) => {
    this.setState({anchorEl: null});
  };

  formatDate = date => (dateFormat(date, true))

  isSameDate(a, b) {
    return Math.abs(a - b) < (1000 * 3600 * 24) && a.day() === b.day();
  }

  downloadReportsAsExcel = (e) => {
    e.stopPropagation()
    const {smsType, startDate, endDate, mobileNo, senderIds} = this.state;
    var increasedEndDate24hour = endDate
    if(this.isSameDate(moment(startDate),moment(endDate)) && !this.isSameDate(moment(endDate),moment())){
      increasedEndDate24hour = moment(endDate);
      increasedEndDate24hour.hour(increasedEndDate24hour.hour()+1);
    }

    this.setState({showWait: true, jobId: null});
    window.localStorage.removeItem(JOB_ID_KEY);
    this.props.getSMSReportExportJobID({
      startDate:startDate.startOf('day').valueOf(),
      endDate: endDate.endOf('day').valueOf(),
      mobileNo: mobileNo || 'NA',
      senderIds:senderIds && senderIds.length>0?senderIds: [],
      smsType
    })
  }

  handleMobileNoChange = (event) => this.setState({mobileNo: event.target.value})

  handleSenderIdChange = (event) => {
    this.setState({senderIds:event.target.value});
  }

  render() {
    const {smsType, startDate, endDate, mobileNo, senderIds, showWait, jobId, isJobCompleted, anchorEl} = this.state;
    const {smsDetails} = this.props;
    const isMobile = window.isMobile();
    const open = Boolean(anchorEl);
    const id = open ? 'static-date-range-popover' : undefined;
    const formatRangeView = () => {
      if (!startDate && !endDate) return 'Select date range';
      const startStr = startDate ? startDate.format('MMM D, YYYY') : 'Start Date';
      const endStr = endDate ? endDate.format('MMM D, YYYY') : 'End Date';
      return `${startStr} – ${endStr}`;
    };
    return (
      <>
        <Heading>Refine Your SMS Reports</Heading>
        <div className='sms-small-container'>
          <div style={{display: 'flex', gap: 16, alignItems: 'center', flexWrap: 'wrap'}}>
            <LocalizationProvider localeText={{okButtonLabel: 'Apply'}}>
              <div>
                <Button
                  aria-describedby={id}
                  variant="outlined"
                  onClick={this.handleClick}
                  startIcon={<CalendarTodayOutlined />}
                  sx={{
                    textTransform: 'none',
                    justifyContent: 'space-between',
                    px: 2,
                    py: 1.2,
                    minWidth: 250,
                    borderColor: 'divider',
                    color: 'text.primary',
                    '&:hover': {
                      borderColor: 'primary.main'
                    }
                  }}
                >
                  <Typography variant="body2" fontWeight={500}>
                    {formatRangeView()}
                  </Typography>
                </Button>

                <Popover
                  id={id}
                  open={open}
                  anchorEl={anchorEl}
                  onClose={this.handleClose}
                  anchorOrigin={{
                    vertical: 'bottom',
                    horizontal: 'left',
                  }}
                  transformOrigin={{
                    vertical: 'top',
                    horizontal: 'left',
                  }}
                  PaperProps={{
                    elevation: 8,
                    sx: { borderRadius: 2, mt: 1 },
                  }}
                >
                  <StaticDateRangePicker
                    value={[startDate, endDate]}
                    onChange={this.handleDateChange}
                    onAccept={this.handleDateChange}
                    displayStaticWrapperAs="desktop"
                    slots={{
                      actionBar: () => (
                        <div style={{display: 'flex', gridRow: 3, gridColumn: 2, justifySelf: 'end', padding: 16, paddingTop: 0, gap: 16}}>
                          <Button size="small" onClick={this.handleClose}>
                            Cancel
                          </Button>
                          <Button
                            size="small"
                            variant="contained"
                            onClick={(e) => {
                              this.props.applyFilter(this.state)
                              this.handleClose()
                            }}
                            disabled={!startDate || !endDate}
                          >
                            Apply
                          </Button>
                        </div>
                      )
                    }}
                    slotProps={{
                      shortcuts: {
                        items: isMobile ? [] : shortcutsItems
                      }
                    }}
                    calendars={isMobile ? 1 : 2}
                  />
                </Popover>
              </div>
            </LocalizationProvider>
            <Select
              value={ smsType }
              fullWidth={ isMobile }
              onChange={ this.handleChange }
              sx={{minWidth: 150}}
              label="SMS Type"
              options={[
                {value: 'ALL', name: 'All'},
                ...smsDetails.smsType && smsDetails.smsType.length > 1 ? smsDetails.smsType.map(el => ({value: el, name: langMap[el] || el})) : []]
              }
            />
            <Select
              multiple
              label="Headers"
              value={senderIds}
              onChange={this.handleSenderIdChange}
              fullWidth={isMobile}
              onClose={() => {
                if (!isEqual(this.senderIds, this.state.senderIds)) {
                  this.senderIds = this.state.senderIds
                  this.props.applyFilter(this.state)
                }
              }}
              options={smsDetails?.senderIds || []}
              sx={{width: 150}}
            />
            <Button
              startIcon={showWait ? <CircularProgress size={16} /> : <FileDownload />}
              onClick={this.downloadReportsAsExcel}
              disabled={showWait}
              variant='outlined'
            >Download</Button>
            
            <div style={{display: 'flex', alignItems: 'center', gap: 8, marginLeft: 'auto'}}>
              <TextField
                label="Search By Mobile Number"
                placeholder="Enter mobile number"
                id="mobileNo"
                value={mobileNo}
                onChange={this.handleMobileNoChange}
                maxLength="10"
                style={{minWidth: 200}}
                variant="standard"
                size="small"
              />
              <Tooltip title="Search">
                <IconButton aria-label="Search" onClick={e => {e.stopPropagation(); this.props.applyFilter(this.state)}}>
                  <Search />
                </IconButton>
              </Tooltip>
              {mobileNo &&
              <Tooltip title="Clear">
                <IconButton aria-label='Clear Search' onClick={(e) => {e.stopPropagation(); this.setState({mobileNo: ''}, () => this.props.applyFilter(this.state))}}>
                  <HighlightOff />
                </IconButton>
              </Tooltip>
              }
            </div>
          </div>
          <a href='' id='download-full-report' style={ {display: 'none'} } target='_blank' />
        </div>
        <Collapse in={!!jobId || isJobCompleted}>
          {isJobCompleted ?
            <Alert icon={<Check fontSize="inherit" />} severity="success" style={{display: 'flex', alignItems: 'center', marginBottom: 8}}>
              Your export is completed, please<Button onClick={this.handleExport}>click here</Button>to download the report.
            </Alert>
            :
            <Alert severity="info" style={{display: 'flex', alignItems: 'center', marginBottom: 8}}>
              Your export is in progress <CircularProgress size={20} style={{marginLeft: 16}} />
            </Alert>
          }
        </Collapse>
      </>
    )
  }
}
function mapStateToProps(state){
  return {
    smsHistoryExportJobID : state.smsHistory.smsHistoryExportJobID
  };
}
export default connect(mapStateToProps, {getSMSReportExportJobID})(Filter);
